// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting_item {
    margin-top: 15px;
    background-color: rgb(239, 238, 225);
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    border-radius: 10px;
    margin-left: 20px;
    justify-content: center;
    align-items: center;
    box-shadow: rgba(117, 121, 124, 0.3) 0px 1px 2px 0px, rgba(93, 96, 99, 0.15) 0px 2px 6px 2px; 
}`, "",{"version":3,"sources":["webpack://./src/app/user-settings/user-settings.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,4FAA4F;AAChG","sourcesContent":[".setting_item {\n    margin-top: 15px;\n    background-color: rgb(239, 238, 225);\n    padding: 10px 20px;\n    display: flex;\n    flex-direction: row;\n    border-radius: 10px;\n    margin-left: 20px;\n    justify-content: center;\n    align-items: center;\n    box-shadow: rgba(117, 121, 124, 0.3) 0px 1px 2px 0px, rgba(93, 96, 99, 0.15) 0px 2px 6px 2px; \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
